import { render, staticRenderFns } from "./log-inbound.vue?vue&type=template&id=1506866b&"
import script from "./log-inbound.vue?vue&type=script&lang=js&"
export * from "./log-inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports